// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___3rzfA","account":"styles__account___2Z-eE","body":"styles__body___3xmrT","title":"styles__title___WCzet","subTitle":"styles__subTitle___3mwwN"};